"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createOrderCharge;
function createOrderCharge() {
    var fixture = init();

    function init() {
        return {};
    }

    return {
        setChargeId: function setChargeId(chargeId) {
            fixture.chargeId = chargeId;
            return this;
        },
        setAmount: function setAmount(amount) {
            fixture.amount = amount;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}